// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type DocumentPreviewQueryVariables = Types.Exact<{
  target: Types.DocumentPreviewTargetInput;
}>;


export type DocumentPreviewQuery = { __typename?: 'Query', documentPreview: { __typename?: 'DocumentPreview', status: Types.DocumentPreviewStatus, renderer?: Types.DocumentPreviewRenderer | null, fileName: string, url?: string | null, expiresAt?: any | null, failureCode?: string | null } };


export const DocumentPreviewDocument = gql`
    query DocumentPreview($target: DocumentPreviewTargetInput!) {
  documentPreview(target: $target) {
    status
    renderer
    fileName
    url
    expiresAt
    failureCode
  }
}
    `;

/**
 * __useDocumentPreviewQuery__
 *
 * To run a query within a React component, call `useDocumentPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentPreviewQuery({
 *   variables: {
 *      target: // value for 'target'
 *   },
 * });
 */
export function useDocumentPreviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentPreviewQuery, DocumentPreviewQueryVariables> & ({ variables: DocumentPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentPreviewQuery, DocumentPreviewQueryVariables>(DocumentPreviewDocument, options);
      }
export function useDocumentPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentPreviewQuery, DocumentPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentPreviewQuery, DocumentPreviewQueryVariables>(DocumentPreviewDocument, options);
        }
// @ts-ignore
export function useDocumentPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentPreviewQuery, DocumentPreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentPreviewQuery, DocumentPreviewQueryVariables>;
export function useDocumentPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentPreviewQuery, DocumentPreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentPreviewQuery | undefined, DocumentPreviewQueryVariables>;
export function useDocumentPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentPreviewQuery, DocumentPreviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentPreviewQuery, DocumentPreviewQueryVariables>(DocumentPreviewDocument, options);
        }
export type DocumentPreviewQueryHookResult = ReturnType<typeof useDocumentPreviewQuery>;
export type DocumentPreviewLazyQueryHookResult = ReturnType<typeof useDocumentPreviewLazyQuery>;
export type DocumentPreviewSuspenseQueryHookResult = ReturnType<typeof useDocumentPreviewSuspenseQuery>;
export type DocumentPreviewQueryResult = ApolloReactCommon.QueryResult<DocumentPreviewQuery, DocumentPreviewQueryVariables>;